'use strict';

(function () {

  angular.module('specsguardApp')
    .directive('sgUserIcon', sgUserIcon);

  function sgUserIcon () {
    return {
      scope: {
        user: '=',
        overrideColor: '@'
      },
      transclude: true,
      templateUrl: 'app-legacy/components/sg-user-icon/user-icon.html',
      controller: 'sgUserIconCtrl',
      controllerAs: 'iconCtrl',
    };
  }

})();

